import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { HiOutlineScale } from "react-icons/hi2";

import Badge from "@/components/atoms/Badge";
import BaseColumn from "@/components/molecules/table/BaseColumn";
import { searchColumns } from "@/components/organisms/search/searchColumns";

const legalFormColumn = (t: TFunction): ColumnDef<CompanyEntryDto> =>
  BaseColumn<CompanyEntryDto>({
    accessorFn: (row) => row.info.legal_form,
    id: searchColumns(t).legal_form.id,
    header: () => searchColumns(t).legal_form.name,
    cell: (info) => info.getValue<string>() && <Badge size={"sm"} label={info.getValue<string>()} />,
    meta: {
      heading: {
        icon: HiOutlineScale,
      },
    },
  });

export default legalFormColumn;
